import { motion } from "framer-motion";

export default function Statement() {
  return (
    <section
      className="relative -mt-8 rounded-t-[48px] bg-white overflow-hidden py-28 sm:py-36 lg:py-44"
      data-testid="statement-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
        <motion.span
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="inline-flex items-center rounded-full border border-[#5B4199]/40 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#5B4199] mb-8"
        >
          Why Expante
        </motion.span>
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          className="font-display text-[11vw] sm:text-7xl lg:text-[104px] font-extrabold tracking-tight leading-[0.98] text-[#5B4199]"
        >
          {["Your team in India.", "Run your way."].map((line, i) => (
            <span className="masked-line" key={line}>
              <motion.span
                variants={{
                  hidden: { y: "115%" },
                  visible: { y: 0, transition: { duration: 0.9, delay: 0.1 + i * 0.12, ease: [0.22, 1, 0.36, 1] } },
                }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8 max-w-2xl mx-auto text-base sm:text-lg text-[#475569] leading-relaxed"
          data-testid="statement-subcopy"
        >
          Build and lead your India team as an extension of your business. You retain control over
          the people, priorities, culture, and outcomes; Expante manages the local employment and
          operational complexity.
        </motion.p>
      </div>
    </section>
  );
}
